module.exports = __webpack_public_path__ + "img/Ellipse.a9fb74a9.png";